import React from "react"
import {Button, Stack, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

const DoYouWantInspectionReminder = ({ onSelect }) => {
    const { t } = useTranslation()

    const handleSelect = (action: boolean) => {
        if (onSelect) {
            onSelect(action);
        }
    };

    return (<Stack spacing={2} alignItems="center" width="100%" style={{textAlign: 'center'}}>
        <div style={{maxWidth: '90%'}}>
            <Typography variant="subtitle1">
                {t('selfService.doYouWantToOrderInspectionReminder')}
            </Typography>
            <Typography variant="subtitle1">
                {t('selfService.doYouWantToOrderInspectionReminderInfo')}
            </Typography>
        </div>
        <Stack direction="row" spacing={8} width="100%" justifyContent="center">
            <Button
                variant="contained"
                color="primary"
                onClick={() => handleSelect(false)}
            >
                {t('selfService.noThankYou')}
            </Button>
            <Button
                variant="contained"
                color="secondary"
                onClick={() => handleSelect(true)}
            >
                {t('common.yes')}
            </Button>
        </Stack>
    </Stack>)
}

export default DoYouWantInspectionReminder
